import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table, Input, Select, Badge } from "antd";
import ticketsActions from "../../../redux/ticket/actions";
import dayjs from "dayjs";
import { epochToNormalDate, convertToEuro } from "../../../utils/utility";
import SingleTableRowDropdown from "./SingleTableRowDropdown";
import "./index.css";
import DateSearchForm from "../../UI/DateSearchForm";
const { Option } = Select;

const allColumns = [
  {
    title: "Статус",
    dataIndex: "status",
    key: "status",
    render: (_, record) => {
      const statusMap = {
        0: { text: "Валиден", badge: "success" },
        1: { text: "Обслужен", badge: "processing" },
        "-1": { text: "Изтекъл", badge: "default" },
        "-2": { text: "Отменен", badge: "error" },
      };

      const status = statusMap[String(record.status)] || {
        text: "Неизвестен",
        badge: "warning",
      };

      return <Badge status={status.badge} text={status.text} />;
    },
  },

  {
    title: "Тип резервация",
    dataIndex: "isAnnulReserved",
    key: "isAnnulReserved",
    render: (_, record) =>
      record.isAnnulReserved ? (
        <Badge status="error" text="Анулирана" />
      ) : (
        <Badge status="success" text="Валидна" />
      ),
  },
  {
    title: "TickSys Номер",
    dataIndex: "ticketNumber",
    key: "ticketNumber",
  },
  {
    title: "Курс",
    key: "name",
    dataIndex: "name",
    render: (_, record) => `${record.cityFrom} - ${record.cityTo}`,
  },
  {
    title: "Име",
    dataIndex: "forPerson",
    key: "forPerson",
  },
  {
    title: "Имейл",
    dataIndex: "email",
    key: "email",
  },
  {
    title: "Телефонен номер",
    dataIndex: "phone",
    key: "phone",
  },
  {
    title: "Заминаване",
    key: "courseDate",
    dataIndex: "courseDate",
    render: (_, record) =>
      record.courseDateTime && epochToNormalDate(record.courseDateTime),
  },
  {
    title: "Дата на продажба",
    key: "saleDate",
    dataIndex: "saleDate",
    render: (_, record) =>
      record.oprSalelDateTime && epochToNormalDate(record.oprSalelDateTime),
  },
];

const reservationColumns = [
  {
    title: "Статус",
    dataIndex: "status",
    key: "status",
    render: (_, record) => {
      const statusMap = {
        0: { text: "Валиден", badge: "success" },
        1: { text: "Обслужен", badge: "processing" },
        "-1": { text: "Изтекъл", badge: "default" },
        "-2": { text: "Отменен", badge: "error" },
      };

      const status = statusMap[String(record.status)] || {
        text: "Неизвестен",
        badge: "warning",
      };

      return <Badge status={status.badge} text={status.text} />;
    },
  },
  {
    title: "Тип резервация",
    dataIndex: "isAnnulReserved",
    key: "isAnnulReserved",
    render: (_, record) =>
      record.isAnnulReserved ? (
        <Badge status="error" text="Анулирана" />
      ) : (
        <Badge status="success" text="Валидна" />
      ),
  },
  {
    title: "Курс",
    key: "name",
    dataIndex: "name",
    render: (_, record) => `${record.cityFrom} - ${record.cityTo}`,
  },
  {
    title: "Име",
    dataIndex: "forPerson",
    key: "forPerson",
  },
  {
    title: "Имейл",
    dataIndex: "email",
    key: "email",
  },
  {
    title: "Телефонен номер",
    dataIndex: "phone",
    key: "phone",
  },

  {
    title: "Дата на резервация",
    key: "reservationDate",
    dataIndex: "reservationDate",
    render: (_, record) => epochToNormalDate(record.oprReservedDateTime),
  },
];

const ticketColumns = [
  {
    title: "Статус",
    dataIndex: "status",
    key: "status",
    render: (_, record) => {
      const statusMap = {
        0: { text: "Валиден", badge: "success" },
        1: { text: "Обслужен", badge: "processing" },
        "-1": { text: "Изтекъл", badge: "default" },
        "-2": { text: "Отменен", badge: "error" },
      };

      const status = statusMap[String(record.status)] || {
        text: "Неизвестен",
        badge: "warning",
      };

      return <Badge status={status.badge} text={status.text} />;
    },
  },

  {
    title: "Тип продажба",
    dataIndex: "isAnnulSale",
    key: "isAnnulSale",
    render: (_, record) =>
      record.isAnnulSale ? (
        <Badge status="error" text="Анулирана" />
      ) : (
        <Badge status="success" text="Валидна" />
      ),
  },
  {
    title: "TickSys",
    dataIndex: "ticketNumber",
    key: "ticketNumber",
  },
  {
    title: "Курс",
    key: "name",
    dataIndex: "name",
    render: (_, record) => `${record.cityFrom} - ${record.cityTo}`,
  },

  {
    title: "Име",
    dataIndex: "forPerson",
    key: "forPerson",
  },
  {
    title: "Имейл",
    dataIndex: "email",
    key: "email",
  },
  {
    title: "Телефонен номер",
    dataIndex: "phone",
    key: "phone",
  },
  {
    title: "Заминаване",
    key: "courseDate",
    dataIndex: "courseDate",
    render: (_, record) => epochToNormalDate(record.courseDateTime),
  },
  {
    title: "Дата на продажба",
    key: "saleDate",
    dataIndex: "saleDate",
    render: (_, record) => epochToNormalDate(record.oprSalelDateTime),
  },
  {
    title: "Цена",
    key: "price",
    dataIndex: "price",
    render: (_, record) => `€ ${record.price.toFixed(2)}`,
  },
  {
    title: "Цена BGN",
    key: "price",
    dataIndex: "price",
    render: (_, record) => `${convertToEuro(record.price)?.toFixed(2)}лв`,
  },
];

const ReservationTicketsTable = () => {
  const dispatch = useDispatch();
  const { getReservationInfoByPeriod } = ticketsActions;
  const { adminToken, companies } = useSelector((state) => state.mainReducer);
  const { reservationInfoByPeriod } = useSelector(
    (state) => state.ticketReducer
  );

  const [startDate, setStartDate] = useState(dayjs().startOf("day"));
  const [startTime, setStartTime] = useState(dayjs().startOf("day"));
  const [endDate, setEndDate] = useState(dayjs().endOf("day"));
  const [endTime, setEndTime] = useState(dayjs().endOf("day"));

  const [filterType, setFilterType] = useState("tickets");
  const [searchTerm, setSearchTerm] = useState("");

  const combinedStartDateTime = startDate
    .hour(startTime.hour())
    .minute(startTime.minute());

  const combinedEndDateTime = endDate
    .hour(endTime.hour())
    .minute(endTime.minute());

  useEffect(() => {
    if (adminToken && companies.length > 0) {
      dispatch(
        getReservationInfoByPeriod(
          adminToken,
          companies[0]?.id,
          combinedStartDateTime.unix().toString(),
          combinedEndDateTime.unix().toString()
        )
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const filteredReservationsAll = reservationInfoByPeriod?.filter(
    (reservation) => {
      const searchLower = searchTerm.toLowerCase();
      return (
        `${reservation.forPerson} ${reservation.email} ${reservation.phone}`
          .toLowerCase()
          .includes(searchLower) ||
        epochToNormalDate(reservation.courseDateTime).includes(searchTerm)
      );
    }
  );

  const filteredReservationsTickets = reservationInfoByPeriod
    ?.filter((reservation) => reservation.ticketNumber !== null)
    ?.filter((reservation) => {
      const searchLower = searchTerm.toLowerCase();
      return (
        `${reservation.forPerson} ${reservation.email} ${reservation.phone}`
          .toLowerCase()
          .includes(searchLower) ||
        epochToNormalDate(reservation.courseDateTime).includes(searchTerm)
      );
    });

  const filteredReservationsFailed = reservationInfoByPeriod
    ?.filter((reservation) => reservation.ticketNumber === null)
    ?.filter((reservation) => {
      const searchLower = searchTerm.toLowerCase();
      return (
        `${reservation.forPerson} ${reservation.email} ${reservation.phone}`
          .toLowerCase()
          .includes(searchLower) ||
        epochToNormalDate(reservation.oprReservedDateTime).includes(searchTerm)
      );
    });

  return (
    <>
      <DateSearchForm
        startDate={startDate}
        endDate={endDate}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        startTime={startTime}
        endTime={endTime}
        setStartTime={setStartTime}
        setEndTime={setEndTime}
        combinedStartDateTime={combinedStartDateTime}
        combinedEndDateTime={combinedEndDateTime}
        heading="Лог таблица"
      />

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "10px",
          marginTop: "15px",
        }}
      >
        <Input
          className="send-email-search-input"
          placeholder="Търси по име, имейл, дата или телефонен номер"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <Select
          className="reservation-types-input"
          value={filterType}
          onChange={(value) => setFilterType(value)}
        >
          <Option value="all">Всички</Option>
          <Option value="reservation">Резервации</Option>
          <Option value="tickets">Билети</Option>
        </Select>
      </div>
      {filterType === "all" && (
        <Table
          size="small"
          pagination={{ pageSize: 100 }}
          scroll={{ x: "max-content" }}
          rowKey={(record, index) => index}
          columns={allColumns}
          expandable={{
            expandedRowRender: (record) => (
              <SingleTableRowDropdown record={record} />
            ),
          }}
          dataSource={filteredReservationsAll?.reverse()}
        />
      )}

      {filterType === "tickets" && (
        <Table
          size="small"
          scroll={{ x: "max-content" }}
          pagination={{ pageSize: 100 }}
          rowKey={(record, index) => index}
          columns={ticketColumns}
          expandable={{
            expandedRowRender: (record) => (
              <SingleTableRowDropdown record={record} />
            ),
          }}
          dataSource={filteredReservationsTickets?.reverse()}
        />
      )}
      {filterType === "reservation" && (
        <Table
          size="small"
          pagination={{ pageSize: 100 }}
          scroll={{ x: "max-content" }}
          rowKey={(record, index) => index}
          columns={reservationColumns}
          expandable={{
            expandedRowRender: (record) => (
              <SingleTableRowDropdown record={record} />
            ),
          }}
          dataSource={filteredReservationsFailed?.reverse()}
        />
      )}
    </>
  );
};

export default ReservationTicketsTable;
